import React from "react";
import { Drawer } from "@design-system/Drawer";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import styles from "./ImporterDrawerShell.module.scss";

interface Props {
    title: string;
    titleAddon?: React.ReactNode;
    open?: boolean;
    onClose: () => void;
    statusItems: string[];
    submitLabel: string;
    submitHotkeyDescription: string;
    submitCount?: number;
    isSubmitting?: boolean;
    onSubmit: () => void;
    children: React.ReactNode;
}

export const ImporterDrawerShell: React.FC<Props> = ({
    title,
    titleAddon,
    open = true,
    onClose,
    statusItems,
    submitLabel,
    submitHotkeyDescription,
    submitCount,
    isSubmitting,
    onSubmit,
    children,
}) => {
    const headerAddon = (
        <div className={styles.headerTitle}>
            {title}
            {titleAddon}
        </div>
    );

    return (
        <Drawer
            direction="right"
            onClose={onClose}
            open={open}
            size="fullScreen"
            headerAddonLeft={headerAddon}
            noPadding
        >
            <div className={styles.container}>
                <div className={styles.statusBar}>
                    {statusItems.map((statusItem) => (
                        <span key={statusItem} className={styles.statusItem}>
                            {statusItem}
                        </span>
                    ))}
                </div>
                <div className={styles.gridWrapper}>{children}</div>
                <CommandIsland className={styles.commandBar}>
                    <WithHotkey
                        hotKey="mod+enter"
                        hotKeyOptions={{
                            description: submitHotkeyDescription,
                        }}
                        hotKeyDisplayPosition="inline"
                    >
                        {(hotkeyHint) => (
                            <Button
                                variant="primary"
                                size="md"
                                onClick={onSubmit}
                                disabled={isSubmitting}
                                rightIcon={
                                    <>
                                        {!isSubmitting &&
                                            submitCount !== undefined && (
                                                <span
                                                    data-slot-box=""
                                                    className={
                                                        styles.submitCount
                                                    }
                                                >
                                                    {submitCount}
                                                </span>
                                            )}
                                        {hotkeyHint}
                                    </>
                                }
                            >
                                {isSubmitting ? "Importing…" : submitLabel}
                            </Button>
                        )}
                    </WithHotkey>
                </CommandIsland>
            </div>
        </Drawer>
    );
};
